import {
  FilterConfig,
  FilterDateOptions,
} from 'src/app/shared/component/filter/universal-filter/universal-filter.interface';
import { UniversalFilterModel } from './universal-filter.model';

export interface UniversalFilterState {
  filters: UniversalFilterModel;
  config: FilterConfig;
  dateOptions: FilterDateOptions | null;
}

export const initialUniversalFilterState: UniversalFilterState = {
  filters: {},
  config: {},
  dateOptions: null,
};
